import { Component, Input, OnInit } from '@angular/core';
import { getISOWeek } from 'date-fns';
import { PoolerUser } from 'server/shared/models/user';
import { AvailabilityWeek } from '../../users/availability-edit/availability-week.model';

@Component({
  selector: 'app-availability-week-item',
  templateUrl: 'availability-week-item.component.html',
  styleUrls: ['availability-week-item.component.scss'],
})
export class AvailabilityWeekItemComponent implements OnInit {
  @Input() week?: AvailabilityWeek;
  @Input() user?: PoolerUser;

  weekNumber?: number;

  constructor() {}

  ngOnInit() {
    if (!this.week) {
      return;
    }
    this.weekNumber = getISOWeek(this.week.startDate);
  }

  trackByDay(_: number, day: { utcDate: Date; dateString: string }): string {
    return day.dateString;
  }
}
